import React from "react";
// import TableComandas from "../components/TableComandas";
import AppClienteReactTable from "../table/AppClienteReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Clientes = () => {
  return (
    <>
      <AppClienteReactTable />
      {/* <TableComandas /> */}

    </>
  );
};

export default Clientes;
